// BL-2570 (moved to core-admin by BL-2643) — the one look for an @mention,
// everywhere admin shows one: a note while typing (NoteEditor), a saved note
// (NoteBody), and an @Inbox item's stored delivery record, chipped once at
// send time (packages/notifications). Slack's rule: a teammate is a teal chip,
// the reader's own name is a yellow chip. Signed off by Dan Saper, 2026-10-14.
//
// COLOR, measured with `node scripts/contrast.mjs` (ADR 051 — Contrast Floor):
//   - teammate: --teal-800 on --teal-100 .............. 7.65:1  text ✓ (needs 4.5)
//   - your own: --ink-900 on --warning-200 ............ 13.55:1 text ✓ (needs 4.5)
// The chip fill is decoration, so it has no non-text floor. The "@" and the
// weight carry the mention, and the name itself says whose it is, so color is
// never the only signal (WCAG 1.4.1).

const CHIP_BASE = 'rounded px-1 font-medium';

/** A teammate's mention. */
export const MENTION_CHIP_CLASS = `${CHIP_BASE} bg-[var(--teal-100)] text-[var(--teal-800)]`;

/** The reader's own name. */
export const OWN_MENTION_CHIP_CLASS = `${CHIP_BASE} bg-[var(--warning-200)] text-[var(--ink-900)]`;

/**
 * The chip class for one mention.
 *
 * @param isOwn - the mention names the person reading.
 * @returns the class string for that chip.
 */
export function mentionChipClass(isOwn: boolean): string {
  return isOwn ? OWN_MENTION_CHIP_CLASS : MENTION_CHIP_CLASS;
}
